/*
 Auto-generated by generate-java-to-ts-maven-plugin. Do not edit.
 Source: de.mhus.vance.api.magrathea.MagratheaWorkflowSource
*/
export var MagratheaWorkflowSource;
(function (MagratheaWorkflowSource) {
    MagratheaWorkflowSource["PROJECT"] = "PROJECT";
    MagratheaWorkflowSource["TENANT"] = "TENANT";
})(MagratheaWorkflowSource || (MagratheaWorkflowSource = {}));
//# sourceMappingURL=MagratheaWorkflowSource.js.map